/**
 * @generated SignedSource<<171aeed8432f5ca5db650f0f80086306>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecruitDetails_user$data = {
  readonly dId: any | null;
  readonly panelist: {
    readonly dId: any | null;
  } | null;
  readonly vpmUserId: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitInstructions_user">;
  readonly " $fragmentType": "RecruitDetails_user";
};
export type RecruitDetails_user$key = {
  readonly " $data"?: RecruitDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitDetails_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitDetails_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PanelistNode",
      "kind": "LinkedField",
      "name": "panelist",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecruitInstructions_user"
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};
})();

(node as any).hash = "e9c54ded4a4cb2889712840db1c840e8";

export default node;
